import Ajax from "Utils/ajax";

export const loginRequest = data => Ajax.post("admin/login", data);

export const getLogo = (data) => Ajax.post('configs/getCompanyLogo', data, { Authorization: 'Intranet' });

export const logoutRequest = data => Ajax.post("admin/logout", data);
export const getTips = data => Ajax.post("configs/getTips", data); //sagar add this api for get tips for login page
